module.exports = __webpack_public_path__ + "static/media/maxigo-splash.47fba791.png";